var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9998 20.8H4.7998V40C4.7998 41.7673 6.23249 43.2 7.9998 43.2H39.9998C41.7671 43.2 43.1998 41.7673 43.1998 40V20.8H39.9998M7.9998 20.8L23.9998 30.4L39.9998 20.8M7.9998 20.8V11.2C7.9998 7.66536 10.8652 4.79999 14.3998 4.79999H33.5998C37.1344 4.79999 39.9998 7.66537 39.9998 11.2V20.8",
    stroke: "#00123A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.4929f4b3da235f2b9409f82e67e14d86.svg";
export { ForwardRef as ReactComponent };